import { IssueTypeTranslated } from 'Configuration/Paco'
import moment from 'moment'
import 'moment-timezone'

interface Props {
  id: number
  code: string
  issueCategory: string
  requestedAt: any
  requiredDate: any
  jobStatus: string
  onClick?: (id: number, issueCategory: string) => void
}

const RequestCard: React.FC<Props> = ({
  id,
  code,
  issueCategory,
  requestedAt,
  requiredDate,
  jobStatus,
  onClick,
}) => {
  return (
    <>
      <div
        className='card border shadow rounded-3 overflow-hidden h-150px my-5 cursor-pointer'
        id='issue-request-card'
        onClick={() => {
          if (onClick) {
            onClick(id, issueCategory)
          }
        }}>
        <div className='card-body'>
          <div className='row h-100' style={{ columnGap: 0 }}>
            <div className='col-4 bg-danger text-center h-100 d-flex flex-column align-items-center justify-content-center'>
              <div className='text-white fs-6 fw-bold'>ลำดับที่</div>
              <div className='text-white fs-2 fw-bold'>{id}</div>
            </div>
            <div className='col-8 bg-white d-flex flex-column justify-content-center px-5 pe-8'>
              <div className='fs-5 fw-bold'>
                {/* @ts-ignore */}
                {issueCategory ? IssueTypeTranslated[issueCategory] : '-'}
              </div>
              <div className='fs-6 text-gray mb-2'>{code ?? '-'}</div>
              <div className='separator mb-2' style={{ borderWidth: 1, borderColor: '#000' }}></div>
              <div>วันที่แจ้ง: {moment(requestedAt).tz('Asia/Bangkok').format('DD/MM/YYYY')}</div>
              <div>วันที่ส่ง: {moment(requiredDate).tz('Asia/Bangkok').format('DD/MM/YYYY')}</div>
              <div>สถานะงาน: {jobStatus}</div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        #issue-request-card {
          transition: all 0.3s ease;
        }

        #issue-request-card:hover {
          opacity: 0.7;
        }

        #issue-request-card:active {
          opacity: 0.4;
        }

        #issue-request-card .card-body {
          padding: 0 !important;
        }
      `}</style>
    </>
  )
}

export default RequestCard
